export function getMediaValue(matchMedia, mediaQueries, defaultValue) {
  // if there's no window
  if (typeof matchMedia === 'undefined') {
    // return the default
    return defaultValue;
  }
  return Object.keys(mediaQueries).reduce(function (result, query) {
    // return the new type if the query matches
    if (matchMedia(mediaQueries[query]).matches) {
      return query;
    }

    // otherwise the previous one
    return result;
  }, defaultValue);
}